import {
  BIKE_TAB,
  SITE_TAB, VOUCHER_TAB,
} from './types';

export const INITIAL_STATE = {
  bike_tab: 0,
  site_tab: 0,
  voucher_tab: 0,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case BIKE_TAB:
      return {
        ...state,
        bike_tab: action.payload
      };
    case SITE_TAB:
      return {
        ...state,
        site_tab: action.payload
      };
    case VOUCHER_TAB:
      return {
        ...state,
        voucher_tab: action.payload
      };
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/ui/reducers.js